export enum QuizPoolSource {
  Folder = 'Folder',
  Json = 'Json'
}